import React, { FC, memo, useCallback } from 'react';

import classNames from 'classnames';
import Checkbox from '@zvuk-b2b/react-uikit/ui/Checkbox';

import { DATA_TEST_IDS } from '../../../consts';
import type { AddressTagFilterOptionProps } from './types';

import styles from '../../index.module.scss';

const AddressTagFilterOption: FC<AddressTagFilterOptionProps> = ({ isChecked, tag, onChange }) => {
  const handleChange = useCallback(
    (value: boolean) => {
      onChange(tag.id, value);
    },
    [onChange, tag.id]
  );

  return (
    <li
      className={classNames(styles.tagOption, {
        [styles.tagOptionChecked]: isChecked,
      })}
      data-testid={DATA_TEST_IDS.AUDIO_REPORT_ADDRESS_TAG_OPTION(tag.id)}>
      <Checkbox
        elementId={DATA_TEST_IDS.AUDIO_REPORT_ADDRESS_TAG_OPTION_CHECKBOX(tag.id)}
        buttonClassName={styles.tagCheckboxButton}
        labelClassName={styles.tagCheckboxLabel}
        isChecked={isChecked}
        onChange={handleChange}>
        {tag.title}
      </Checkbox>
    </li>
  );
};

export default memo(AddressTagFilterOption);
